/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 23.02.2016
 */
'use strict';

import React from 'external/react';
import {
    AmdRequireComponent,
    AppContext,
    DataLinkContainer,
    DataNames as LrDataNames,
    PortletComponent,
    translation
} from 'plugin/liferay-widgets-react-web';
import { getPageSelectedStore } from '../stores/StoreFactory';

/*function DebugOut(props) {
    return <pre>{JSON.stringify(props.item, null, 3)}</pre>;
}*/

// eslint-disable-next-line react/prop-types
const MultiTypeRenderer = ({ item, portletId }) => {
// eslint-disable-next-line react/prop-types
    if (Array.isArray(item) && item.length) {
        item = item[ 0 ];
    }

    return !item ? (
        <div className="padding-box">{translation.trans('details-widget-help-1')}<br/>
            {translation.trans('details-widget-help-2')}
        </div>
    ): (
        <AmdRequireComponent dependencies={[ 'DetailsRenderer/' + item.className ]}>
            {(Renderer) => <Renderer item={item} portletId={portletId}/>}
        </AmdRequireComponent>
    );
}

const SelectedDetails = DataLinkContainer.link(MultiTypeRenderer, [ 'item' ], getPageSelectedStore(AppContext));

class DetailsWidget extends PortletComponent {

    constructor(props) {
        super(props);
    }

    isConfigurationNeeded(config) {
        return false;
    }

    renderPortlet(config) {
        return <SelectedDetails item={LrDataNames.PAGE_SELECTED} portletId={this.portletId}/>;
    }
}

export default DetailsWidget;



// WEBPACK FOOTER //
// ./js/widgets/DetailsWidget.jsx